import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import nesProp from 'nested-property'
import styles from './ClientLinkingModal.scss'
import clientStyles from '../clients/clients.scss'

import cs from 'classnames'
import i18n from 'lib/i18n'
import ClientsForm from '../clients/form'
import ClientLinkingSearchResults from './ClientLinkingSearchResult'
import { fetchClients, setClientData, fetchClientOptionsDict, updateErrorBlocRetour, setNotification } from 'state/actions'

// variables out of module
const _ = i18n('inbox')

/**
 * This module render a button witch can be used to link or upload DSDocument
 */
@connect(
    (state) => {
        return {
            data: state.clients.data,
            clientOptionsDict: state.client.clientOptionsDict,
            lang: state.app.lang,
            security: nesProp.get(state, "app.security"),
        }
    }
)
export default class ClientLinkingModal extends React.Component {
    static propTypes = {
        isOpen: React.PropTypes.bool,
        customStyles: React.PropTypes.object,
        key: React.PropTypes.string,
        ticket: React.PropTypes.any,
        onClose: React.PropTypes.func,
        setNotification: React.PropTypes.func
    }

    constructor(props) {
        super(props)
        this.state = {
            selectedClientId: '',
            updateErrorBlocRetourSuccess: false
        }
    }

    /**
     * This function fired when the module attached
     */
    componentDidMount() {

    }

    componentWillMount() {
        const { dispatch, clientOptionsDict } = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
        }
    }

    handleSearch = (data) => {
        this.setState({selectedClientId: ''})
        this.props.dispatch(fetchClients(data, true))
    }

    selectClientMethod = (clientId) => {
        const { selectedClientId } = this.state

        if (!selectedClientId || selectedClientId !== clientId) {
            this.setState({ selectedClientId: clientId })
        } else if (selectedClientId === clientId) {
            this.setState({ selectedClientId: '' })
        }
    }

    clearModalData() {
        const { dispatch } = this.props
        dispatch(setClientData({}))
        this.setState({ selectedClientId: '', updateErrorBlocRetourSuccess: false })
    }

    async onUpdateErrorBlockRetour() {
        const { dispatch, setNotification, ticket } = this.props
        const { selectedClientId } = this.state
        try {
            //extract the blockretId from string that arrives like "BLOCRET_14950"
            const blockretId = ticket.ticketDetails.msg_link_id.split('_')[1]
            const result = await dispatch(updateErrorBlocRetour(ticket.id, selectedClientId, blockretId))
            if (result && result[0] && result[0].error == '0') {
                // success
                this.setState({ updateErrorBlocRetourSuccess: true })
                dispatch(setNotification(`${_('updateErrorBlockRetourSuccess')}`, 'success'))

            } else {
                dispatch(setNotification(`${_(`updateErrorBlockRetourFail${result[0].error}`)}`, 'error'))
            }

        } catch (error) {
            dispatch(setNotification(`${_('updateErrorBlockRetourFail') + ' ' + error}`, 'error'))
            console.warn(error)
        }
    }

    /**
     * Main render function
     */
    render() {
        const { isOpen, customStyles, key, clientOptionsDict, lang, data, onClose, ticket } = this.props
        const { selectedClientId, updateErrorBlocRetourSuccess } = this.state

        return (
            <Modal
                isOpen={isOpen}
                style={customStyles}
                key={key + "innerModal"}
                contentLabel={""}
            >
                <div
                    className={cs(styles.documentsModalContent)}
                    key={key + "innerModal" + Math.random()}
                >
                    <span className={styles.title}>
                        {_('linkClientFromTicketTitle')}
                    </span>

                    <div className={styles.contentWrapper}>

                        {!updateErrorBlocRetourSuccess ?
                            <div className={styles.content}>
                                <div className={cs(styles.formInputContainer, styles.titleLabel)}
                                    key="selectSignaturePlaceholderDocumentModalContentTitleKey">
                                    {_('selectClientForUpdateErrorBlocRetour')}
                                </div>

                                <div className={clientStyles.clientsMain}>
                                    <div className={cs (clientStyles.clientsSearchContainer, styles.clientsSearchContainer)}>
                                        <ClientsForm
                                            {...{
                                                createClientAccess: false,
                                                updateClientAccess: false,
                                                openModal: () => { },
                                                modalState: false
                                            }}
                                            onSubmit={this.handleSearch}
                                            initialValues={{ state: '' }}
                                            clientOptionsDict={clientOptionsDict}
                                            lang={lang}
                                        />
                                        {data &&
                                            <ClientLinkingSearchResults
                                                data={data}
                                                selectClientMethod={this.selectClientMethod}
                                                selectedClientId={selectedClientId}
                                            />
                                        }
                                    </div>
                                </div>

                                <div className={styles.documentsModalButtons}>
                                    <div
                                        onClick={() => {
                                            this.clearModalData()
                                            onClose()
                                        }}
                                        className={styles.cancel}
                                    >
                                        {_("cancel")}
                                    </div>
                                    <button
                                        onClick={async (e) => {
                                            if (!selectedClientId) {
                                                return
                                            }
                                            await this.onUpdateErrorBlockRetour()
                                            // onClose()
                                        }}
                                        className={`${styles.greenButton} "enabled"`}
                                        disabled={!selectedClientId}
                                    >
                                        {_("updateErrorBlock")}
                                    </button>
                                </div>

                            </div>
                            :
                            <div>
                                <div className={cs(styles.formInputContainer, styles.titleLabel)}
                                    key="selectClientUpdateErrorBlocRetourSuccessTitleKey">
                                    {_('selectClientUpdateErrorBlocRetourSuccess')}
                                </div>

                                <div className={styles.documentsModalButtons}>
                                    <button
                                        onClick={async (e) => {
                                            this.clearModalData()
                                            onClose()
                                        }}
                                        className={`${styles.greenButton} "enabled"`}
                                        disabled={!selectedClientId}
                                    >
                                        {_("ok")}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>

                </div>
            </Modal >
        )
    }
}



// WEBPACK FOOTER //
// ./components/inbox/ClientLinkingModal.jsx